import { useContext } from 'react';
import { IntegrationContext } from 'routes/BudgetModule/components/BudgetWithProvider/IntegrationContext';

/* Return an array of the softwares used by the current bind */
export const useGetSoftwares = (): string[] => {
    const integrations = useContext(IntegrationContext);
    return integrations.map((integration) => integration.software);
};
